import { Injectable } from '@angular/core';
import { NzDrawerService } from 'ng-zorro-antd/drawer';

import { ProgramParticipantPreferencesEditDrawerComponent } from '@main-client/src/app/program-participant-preferences/program-participant-preferences-edit-drawer/program-participant-preferences-edit-drawer.component';

import { Account } from '@libs/src/models/account.model';
import { Group } from '@libs/src/models/group.model';
import {
  ProgramAccount,
  ProgramMembership,
} from '@libs/src/models/program-membership.model';
import { Program } from '@libs/src/models/program.model';

@Injectable()
export class ProgramParticipantPreferencesEditDrawerService {
  constructor(public drawerService: NzDrawerService) {}

  openDrawer(
    group: Group,
    program: Program,
    programMembership: ProgramMembership,
    programAccounts: ProgramAccount[],
    user: Account,
  ) {
    return this.drawerService.create({
      nzBodyStyle: { padding: 0 },
      nzContent: ProgramParticipantPreferencesEditDrawerComponent,
      nzData: {
        group,
        program,
        programAccounts,
        programMembership,
        user,
      },
      nzTitle: $localize`:@@programParticipantPreferencesEditDrawer.title: Edit program preferences`,
      nzWidth: '600px',
    });
  }
}
